import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";

const emailAPI = createApi({
    reducerPath: "emailAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        getEmailTemplateList: builder.mutation({
            query: (userQuery) => ({
                url: '/Email/GetEmailTemplateList',
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addEmailTemplate: builder.mutation({
            query: (userDetails) => ({
                url: '/Email/AddEmailTemplate',
                method: 'POST',
                body: transformRequest(userDetails)
            }),
            // invalidatesTags: ['User'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateEmailTemplate: builder.mutation({
            query: (userDetails) => ({
                url: '/Email/UpdateEmailTemplate',
                method: 'POST',
                body: transformRequest(userDetails)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getEmailTemplateListById: builder.query({
            query: (userId) => ({
                url: encryptQueryString(`/Email/GetEmailTemplateListById/?id=${Number(userId)}`),
                method: 'GET'
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllEmailTemplates: builder.query({
            query: () => ({
                url: `/Email/GetAllEmailTemplate`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        sendEmail: builder.mutation({
            query: (data) => ({
                url: `/Email/SendEmailTemplate`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        })
    })
})

export const { useGetEmailTemplateListMutation,
    useUpdateEmailTemplateMutation,
    useAddEmailTemplateMutation,
    useLazyGetEmailTemplateListByIdQuery,
    useLazyGetAllEmailTemplatesQuery,
    useSendEmailMutation,
} = emailAPI

export default emailAPI;